module.exports = __webpack_public_path__ + "img/bgt02.bd1c122f.png";